class Preview {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
    }
    run() {
        this.elPreviewPopup = document.querySelector('[data-preview-popup]')
        if (!this.elPreviewPopup) {
            return
        }

        this.elPreviewPopupContent = this.elPreviewPopup.querySelector('[data-preview-popup-content]')
        if (!this.elPreviewPopupContent) {
            return
        }

        this.elPreviewPopupClose = this.elPreviewPopup.querySelector('[data-preview-popup-close]')
        if (this.elPreviewPopupClose) {
            this.elPreviewPopupClose.addEventListener('click', () => {
                this.close()
            })
        }

        document.querySelectorAll('[data-preview]').forEach((el) => this.init(el))
    }
    init(el) {
        (new PreviewItem(this, el)).run()
    }
    openStart() {
        this.elPreviewPopup.classList.add('preview--is-opening')
    }
    openEnd() {
        this.elPreviewPopup.classList.remove('preview--is-opening')
    }
    open() {
        this.setContent('')
        this.elPreviewPopup.classList.add('preview--is-active')
    }
    setContent(html) {
        this.elPreviewPopupContent.innerHTML = html;
    }
    close() {
        this.elPreviewPopup.classList.remove('preview--is-active')
    }
}

class PreviewItem {
    constructor(parent, el) {
        this.parent = parent
        this.el = el
        this.url = this.el.getAttribute('href')
    }
    run() {
        this.el.addEventListener('click', (ev) => {
            ev.preventDefault()
            this.parent.openStart()
            this.parent.open()
            fetch(this.url).then((response) => {
                return response.text()
            }).then((html) => {
                this.parent.openEnd()
                this.parent.setContent(html)
            })
        })
    }
}


export default Preview